module.exports = __webpack_public_path__ + "img/bitrix.debc74fc.png";